import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'router-transition',
  setup(__props) {

const keepAliveComponents = ref<any[]>([]);
const route = useRoute();
const routeKey = computed(() => route.fullPath);

// const router = useRouter()
watch(
  () => route,
  v => {
    if (v.meta.keepAlive && keepAliveComponents.value.indexOf(v.name) === -1) {
      keepAliveComponents.value.push(v.name);
    }
  },
  { deep: true, immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    class: "router",
    key: routeKey.value
  }, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_KeepAlive, {
        include: keepAliveComponents.value,
        max: 5
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
      ], 1032, ["include"]))
    ]),
    _: 1
  }))
}
}

})